type EventCallback = (topic: string, payload: any) => void;

type InactivityEvent = {
    topic: string;
    payload?: any;
};

export class InactivityEventQueue {
    events: InactivityEvent[] = [];
    callback: EventCallback = undefined;

    queue = (topic: string, payload?: any) => {
        if (this.callback) {
            this.callback(topic, payload);
        } else {
            this.events.push({
                topic: topic,
                payload: payload
            });
        }
    };

    clear = () => {
        this.events = [];
    };

    register = (callback: EventCallback) => {
        this.callback = callback;
    };

    unregister = () => {
        this.callback = undefined;
    };

    replayMissedEvents = () => {
        this.events.forEach(e => {
            if (this.callback) {
                this.callback(e.topic, e.payload);
            }
        });
        this.clear();
    };
}
